import { useState, useEffect } from 'react';
import { getClientType } from '../services/clientConfig';
import { fetchClientJSON } from '../services/clientDataService';

// Hook to load and manage traffic data from strade and varchi
// Uses client-specific paths based on client_type query parameter
const useTrafficData = () => {
  const [stradeData, setStradeData] = useState(null);
  const [varchiData, setVarchiData] = useState(null);
  const [stradeTimeseries, setStradeTimeseries] = useState(null);
  const [varchiTimeseries, setVarchiTimeseries] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        // Load all data files in parallel (cached by clientDataService)
        const clientType = getClientType();
        const [stradeGeo, stradeTimes, varchiGeo, varchiTimes] = await Promise.all([
          fetchClientJSON(clientType, 'strade/streets_geo.json'),
          fetchClientJSON(clientType, 'strade/timeseries_long.json'),
          fetchClientJSON(clientType, 'varchi/varchi_geo.json'),
          fetchClientJSON(clientType, 'varchi/varchi_timeseries_long.json')
        ]);

        // Process strade data - create lookup by street_direction
        const stradeByDirection = {};
        stradeGeo.forEach(item => {
          stradeByDirection[item.street_direction] = item;
        });

        // Process varchi data - create lookup by marker_key
        const varchiByKey = {};
        varchiGeo.forEach(item => {
          varchiByKey[item.marker_key] = item;
        });

        // Process timeseries data - group by street/marker
        const stradeTimesByDirection = {};
        stradeTimes.forEach(item => {
          if (!stradeTimesByDirection[item.street_direction]) {
            stradeTimesByDirection[item.street_direction] = [];
          }
          stradeTimesByDirection[item.street_direction].push(item);
        });

        const varchiTimesByKey = {};
        varchiTimes.forEach(item => {
          if (!varchiTimesByKey[item.marker_key]) {
            varchiTimesByKey[item.marker_key] = [];
          }
          varchiTimesByKey[item.marker_key].push(item);
        });

        setStradeData({
          geo: stradeGeo,
          byDirection: stradeByDirection,
          timeseriesByDirection: stradeTimesByDirection
        });

        setVarchiData({
          geo: varchiGeo,
          byKey: varchiByKey,
          timeseriesByKey: varchiTimesByKey
        });

        setStradeTimeseries(stradeTimes);
        setVarchiTimeseries(varchiTimes);

        setLoading(false);
      } catch (err) {
        console.error('Error loading traffic data:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return {
    stradeData,
    varchiData,
    stradeTimeseries,
    varchiTimeseries,
    loading,
    error
  };
};

export default useTrafficData;